<div class="row mb-3">
  <div class="col-4">
    <h2 i18n>Customer Support</h2>
  </div>
</div>
<div *ngIf="info" class="row">
  <div class="col-md-4">
    <h4>Contact Us</h4>
    <strong i18n>Hours of Operation</strong>
    <ul>
      <li>{{info.contact.hours}}</li>
    </ul>
    <strong i18n>Telephone</strong>
    <ul>
      <li>{{info.contact.phone}}</li>
    </ul>
    <strong i18n>Email Address</strong>
    <ul>
      <li>{{info.contact.email}}</li>
    </ul>
  </div>

  <div class="col-md-4">
    <strong>{{year}} iconectiv Holidays</strong>
    <table class="table table-striped">
      <tr *ngFor="let h of info.holidayList">
        <td>{{h.holidayDateTime|date:'mediumDate'}}</td>
        <td>{{h.name}}</td>
      </tr>
    </table>
  </div>

  <div class="col-md-4">
    <strong>Scheduled Downtimes</strong>
    <table class="table table-striped">
      <thead>
        <th>Start Date/Time</th>
        <th>End Date/Time</th>
      </thead>
      <tbody>
        <tr *ngFor="let sd of info.scheduledDowntimeList">
          <td>{{sd.startDateTime|date:'medium'}}</td>
          <td>{{sd.endDateTime|date:'medium'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
